import { isSaved, onWishlistChange, toggleSaved } from '@theme/wishlist-store';

/**
 * <s-wishlist-button> — heart toggle that saves a product to the wishlist.
 *
 * Markup: data-handle (product handle) and one descendant <button aria-pressed>.
 * aria-pressed mirrors the saved state so styling can use aria-pressed variants
 * and screen readers hear the toggle state. Stays in sync with every other
 * heart for the same product, including in other tabs.
 */
class SWishlistButton extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const signal = this.#ac.signal;
    const button = this.querySelector('button');
    const handle = this.dataset.handle;
    if (!button || !handle) return;

    this.#render(isSaved(handle));
    button.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.#render(toggleSaved(handle));
      },
      { signal }
    );
    onWishlistChange((handles) => this.#render(handles.includes(handle)), signal);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  /** @param {boolean} saved */
  #render(saved) {
    this.querySelector('button')?.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }
}

customElements.define('s-wishlist-button', SWishlistButton);
